import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  return (
    <a
      data-testid="whatsapp-cta"
      href="https://wa.me/6591351039?text=Hi%20Happy%20Home%20Agency%2C%20I%27d%20like%20to%20enquire%20about%20a%20helper."
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-40 group"
      aria-label="Chat on WhatsApp"
    >
      <div className="w-14 h-14 rounded-full bg-[#688A4E] hover:bg-[#56763E] text-white flex items-center justify-center shadow-2xl shadow-black/20 transition-all duration-300 group-hover:scale-110">
        <MessageCircle className="w-6 h-6" />
      </div>
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-[#0A1128] text-white text-xs px-3 py-2 opacity-0 group-hover:opacity-100 transition pointer-events-none">
        Chat with us on WhatsApp
      </span>
    </a>
  );
}
